import React, { Component } from 'react';
import PropTypes from 'prop-types';

class XA extends Component{

    render(){
        const {
            children,
            className,
            id,
            href,
            target,
            title,
            style: styleProps,
            onClick,onMouseEnter,onMouseLeave,onMouseDown,onMouseUp,
            eleRef,
            attrs,
        } = this.props;

        let style = {
            textDecoration:'none',
        };
        style = Object.assign({}, style, styleProps || {});

        return(
            <>
                <a ref={eleRef} className={className} id={id} href={href} target={target}
                   onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseDown={onMouseDown} onMouseUp={onMouseUp}
                   title={title} style={style} {...attrs}>
                    {children}
                </a>
            </>
        )
    }
}

XA.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top', 'framename']),
    title: PropTypes.string,
    children: PropTypes.node,
    eleRef: PropTypes.any,
    onClick: PropTypes.func,
    onMouseEnter : PropTypes.func,
    onMouseLeave : PropTypes.func,
    onMouseDown : PropTypes.func,
    onMouseUp : PropTypes.func,
    attrs: PropTypes.object,
    style:PropTypes.object,
};

XA.defaultProps = {
    attrs:{}
};

export default  XA;

